/**
 * A stretch of the town's perimeter balustrade (lifted from lantern-water's
 * `world.js` `townSurroundings` `rail`): a stone base and cream coping with an
 * iron top rail, stone posts every ~2.1 with caps, and iron balusters between.
 * The root is the stretch's centre; its length runs along local x (the
 * placement turns it).
 *
 * Params: `length` (2.1): the stretch's length.
 */
import * as THREE from 'three';
import { num } from '../kit.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'perimeter_rail',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, m } = ctx;
    const length = num(ctx, 'length', 2.1);
    const count = Math.ceil(length / 2.1);
    box(root, 0, 0.17, 0, length, 0.34, 0.3, m.stone);
    box(root, 0, 0.38, 0, length + 0.08, 0.09, 0.38, m.cream);
    box(root, 0, 0.9, 0, length, 0.065, 0.065, m.iron);
    for (let i = 0; i <= count; i += 1) {
      const x = -length / 2 + (i * length) / count;
      box(root, x, 0.61, 0, 0.28, 1.22, 0.3, m.stone);
      box(root, x, 1.24, 0, 0.4, 0.1, 0.4, m.cream);
    }
    for (let x = -length / 2 + 0.32; x < length / 2; x += 0.34) box(root, x, 0.64, 0, 0.028, 0.48, 0.028, m.iron);
    return { root };
  },
};
